<div class="cu-page">
    <!-- same purple / orange look as the sign-up page -->
    <section class="cu-hero">
        <span class="cu-hero-icon"><i class="bi bi-headset"></i></span>
        <div>
            <h2>We're here to help</h2>
            <p>For queries and support, feel free to contact us</p>
            <span class="cu-hours"><i class="bi bi-clock"></i> {{supportHours}}</span>
        </div>
    </section>

    <ul class="cu-list">
        <li *ngFor="let contact of contacts" class="cu-card">
            <div class="cu-who">
                <span class="cu-label">{{contact.label}}</span>
                <button type="button" class="cu-number" (click)="callNumber(contact.phone)">{{formatPhone(contact.phone)}}</button>
            </div>
            <div class="cu-actions">
                <button type="button" class="cu-btn call" (click)="callNumber(contact.phone)" [attr.aria-label]="'Call ' + contact.label">
                    <i class="bi bi-telephone-fill"></i><span>Call</span>
                </button>
                <button type="button" class="cu-btn wa" (click)="openWhatsApp(contact.phone)" [attr.aria-label]="'WhatsApp ' + contact.label">
                    <i class="bi bi-whatsapp"></i><span>WhatsApp</span>
                </button>
            </div>
        </li>
    </ul>

    <button type="button" class="cu-card cu-video" (click)="openYoutube()">
        <span class="cu-video-icon"><i class="bi bi-play-fill"></i></span>
        <span class="cu-who">
            <span class="cu-label">Help video</span>
            <b>Watch the demo on YouTube</b>
        </span>
        <i class="bi bi-chevron-right cu-chevron"></i>
    </button>
</div>
